// Util Imports
import { ThemeDisplayButton } from "utils/theme";

// Site Nav Header
const HeaderSiteNav = ({ main_nav, additional_nav, header_button, handleShowSearch }) => {
  return (
    <>
      <nav className="sitenav sitenav--center text-sml font-bold">
        <ul className="inlinenavlist noline">
          {typeof main_nav !== "undefined"
            ? main_nav.map((item, index) => {
                return (
                  <li key={index} className={`sitenav__item ${item.add_dropdown ? "sitenav__item--hasdropdown" : ""}`}>
                    {ThemeDisplayButton(item.link, "sitenav__link", false)}
                    <div className="sitenav__item__dropdownarrow"></div>
                    {item.add_dropdown ? (
                      <div className="sitenav__item__dropdown dropdown">
                        <ul className="dropdown__list">
                          {item.dropdown
                            ? item.dropdown.child_links.map((child, child_index) => {
                                return (
                                  <li key={child_index}>
                                    {ThemeDisplayButton(child.child_link, "dropdown__link", false)}
                                  </li>
                                );
                              })
                            : false}
                        </ul>
                      </div>
                    ) : (
                      false
                    )}
                  </li>
                );
              })
            : false}
        </ul>
      </nav>
      <nav className="sitenav sitenav--right text-sml font-bold">
        <ul className="inlinenavlist noline">
          {typeof additional_nav !== "undefined"
            ? additional_nav.map((item, index) => {
                return (
                  <li key={index} className={`sitenav__item ${item.add_dropdown ? "sitenav__item--hasdropdown" : ""}`}>
                    {ThemeDisplayButton(item.link, "sitenav__link", false)}
                    <div className="sitenav__item__dropdownarrow"></div>
                    {item.add_dropdown ? (
                      <div className="sitenav__item__dropdown dropdown">
                        <ul className="dropdown__list">
                          {item.dropdown
                            ? item.dropdown.child_links.map((child, child_index) => {
                                return (
                                  <li key={child_index}>
                                    {ThemeDisplayButton(child.child_link, "dropdown__link", false)}
                                  </li>
                                );
                              })
                            : false}
                        </ul>
                      </div>
                    ) : (
                      false
                    )}
                  </li>
                );
              })
            : false}
          <li className="sitenav__item sitenav__item--btn">
            {ThemeDisplayButton(header_button, "sitenav__btn btn btn--gold", false)}
          </li>
          <li className="sitenav__item sitenav__item--search">
            <button onClick={() => handleShowSearch()} className="search-toggle" title="Search">
              <span className="far fa-search fa--nopad"></span>
            </button>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default HeaderSiteNav;
